

export default {
    async SET_TOTAL_EQUIPMENT_ORDER(state, totalEquipmentOrders) {
        state.totalEquipmentOrders =  parseInt(totalEquipmentOrders) || 0;
    },
    async ADD_NEW_EQUIPMENT_ORDER(state, order) {
        state.equipmentOrders.splice(0, 0, order)
    },
    async SET_EQUIPMENT_ORDER(state, equipmentOrders) {
        state.equipmentOrders = equipmentOrders
    },
    async UPDATE_EQUIPMENT_ORDER(state, order) {
        const equipmentOrderIndex = state.equipmentOrders.findIndex((p) => p.idOrder == order.idOrder)
        Object.assign(state.equipmentOrders[equipmentOrderIndex], order)
    },
    REMOVE_EQUIPMENT_ORDER(state, idOrder) {
        const equipmentOrderIndex = state.equipmentOrders.findIndex((e) => e.idOrder == idOrder)
        state.equipmentOrders.splice(equipmentOrderIndex, 1)
    },
    
    async SET_EQUIPMENT_ORDER_FILTERED(state, equipmentOrders) {
        state.equipmentOrdersFiltered = equipmentOrders
    },

    REMOVE_EQUIPMENT_ORDER_FILTERED(state, idOrder) {
        const equipmentOrderIndex = state.equipmentOrdersFiltered.findIndex((s) => s.idOrder == idOrder)
        state.equipmentOrdersFiltered.splice(equipmentOrderIndex, 1)
    },

}